import OPERATIONS from "./operations.js";

export default function (params) {
  const tables = [].concat(params.tables || []).map((t) => t.replace(/^(.)([0-9])$/, "$10$2"));
  tables.sort();
  const operations = tables.reduce((res, table) => {
    const sign = table.substring(0, 1);
    const t = parseInt(table.substr(1), 10);

    if (!res.length || res[res.length - 1].sign !== sign) {
      // New operation
      res.push({
        name: (OPERATIONS.find((o) => o.sign === sign) || { title: sign }).title,
        sign,
        tables: [],
      });
    }

    const ts = res[res.length - 1].tables;
    if (!ts.length || ts[ts.length - 1].end !== t - 1) {
      ts.push({ start: t, end: t });
    } else {
      ts[ts.length - 1].end = t;
    }

    return res;
  }, []);

  return (
    <div>
      <div>Avec cette activité, tu vas valider :</div>
      <ul style={{ paddingLeft: 40 }}>
        {operations.map((o) => (
          <li key={o.sign}>
            Les {o.name.toLowerCase()} ({o.sign}) de{" "}
            {o.tables
              .map((t) => (t.start == t.end ? "" + t.start : t.start + " à " + t.end))
              .join(", ")
              .replace(/^(.*), (.*)$/, "$1 et $2")}
            .
          </li>
        ))}
      </ul>
    </div>
  );
}
